import moment from 'moment';

export const formatToIsoString = (timestamp: number | string) => {
  const date = moment(timestamp);
  return date.format('MMMM D, YYYY');
};
